



















import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import OrderAllowanceCharge from './OrderAllowanceCharge.vue';
import { GQL_order_order } from '@/queries/__generated__/order';
import Order from './Order.vue';

@Component({
  components: {
    OrderAllowanceCharge,
  },
})
export default class OrderAllowanceCharges extends Vue {
  @Prop(Object) public order!: GQL_order_order;

  @Inject() public documentComponent!: Order;

  private displayAllowanceCharges: boolean =
    this.documentComponent.displaySettings.invoiceAllowanceCharge ||
    this.order.orderAllowanceCharges.some(ac => !ac.percent.isZero());
}
